import { getEmissionsFaktor, getEmissionsFaktorObject } from '../getEmmissionsFaktor';
import { getKennzahl, Kennzahl } from '../strukturiert/Kennzahl';
import { getStaticOption } from '../../../core/forms/helpers/getStaticOption';
import { IDs } from '../../../helpers/IDs';
import { isValid as isValidStrom } from '../validData';
import { KennzahlFaktor } from '../strukturiert/KennzahlFaktor';
import { isRenewableStrom, setKennzahlRenewableStrom } from './setRenewable';

export function extractEnergieStrom(data: any, base: any, standort: any) {
    const standorte = data[IDs.ENT_STANDORT];
    const strom = data[IDs.ENT_ENERGIEDATEN_STROM].filter((item: any) => !standort || standort.tid === item.standort_tid_orig);
    const eigenstrom = data[IDs.ENT_ENERGIEDATEN_EIGENSTROM].filter((item: any) => !standort || standort.tid === item.standort_tid_orig);

    // Standorte-Map
    const veranstaltungen_enabled = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).veranstaltungen_orig === 1;
    const standorteMap: any = {};
    standorte
        // schließen deaktivierte Veranstaltungen oder Veranstaltungen ohne Standorte aus.
        .filter((s: any) => !((s.standort_typ_tid_orig === 5 || s.standort_typ_tid_orig === 6) && (!veranstaltungen_enabled || !s.standort_tid_orig)))
        .forEach((s: any) => standorteMap[s.tid] = s.energiedaten_erfassen_orig === 1 || s.energiedaten_erfassen === 1);
    // console.log(veranstaltungen_enabled, standorte, standorteMap);
    let kenn_verbrauch: Kennzahl;

    /******************** STROM ****************************************************************** */
    strom.forEach((item: any) => {
        const standortTid = item.standort_tid_orig ? item.standort_tid_orig : item.standort_tid;
        if (!standortTid || !standorteMap[standortTid]) {
            return;
        }
        if (
            (!item.monat || item.monat === 0) // nur Jahreswerte
            && isValidStrom(item, IDs.ENT_ENERGIEDATEN_STROM, data)
        ) {
            const jahr = item.jahr;
            if (!base[jahr]) {
                base[jahr] = {};
            }
            // console.log('Strom Item: ', jahr, item);
            base['flags'].hasStrom = true;

            // Wir ermitteln zuerst den Faktor für die Hochrechnung
            let factor_hochrechnung = 1;
            let tage: number;
            let tage_hochrechnung: number;
            const az_von = item.abrechnungszeitraum_von;
            let az_bis = item.abrechnungszeitraum_bis;
            // Tageszeit entfernen
            //  const date_von = new Date(+az_von * 1000);
            //  const date_von2 = new Date(date_von.getFullYear(), date_von.getMonth(), date_von.getDate());
            const date_bis = new Date(+az_bis * 1000);
            const date_bis2 = new Date(date_bis.getFullYear(), date_bis.getMonth(), date_bis.getDate());
            az_bis = date_bis2.getTime() / 1000;
            const abrechnungsart = +item.abrechnungsart;
            const abrechnungsart_name = abrechnungsart ? getStaticOption(IDs.ENT_ENERGIEDATEN_STROM, 'abrechnungsart', abrechnungsart) : null;
            const az = az_bis - az_von;
            // 1 - Reguläre Abrechnung, 2 - Teilabrechnung, 3 - Erste Abrechnung, 4 - Letzte Abrechnung
            // Fall 2 müssen wir nichts machen, da bleibt es beim Faktor 1, da wir nicht hochrechnen.
            if (!abrechnungsart || abrechnungsart === 1) {
                const az_teil_d = tage_hochrechnung = (jahr % 4 === 0 ? 366 : 365);
                const az_d = Math.round(az / 86400);
                factor_hochrechnung = az_teil_d / (az_d + 1);
                tage = az_d + 1;
                // console.log('HR Strom 1', jahr, (az_d + 1), az_teil_d, factor_hochrechnung, item.verbrauch_kwh);
                // console.log('HR Strom 1 AZ', az_von, az_bis, date_bis, date_bis2);
            } else if (abrechnungsart === 3) {
                // Wir rechnen von AZ-Von bis zum Jahresende
                const az_ende = new Date(jahr + 1, 0, 1).getTime() / 1000;
                const az_teil_d = tage_hochrechnung = Math.round((az_ende - az_von) / 86400);
                const az_d = Math.round(az / 86400);
                factor_hochrechnung = az_teil_d / (az_d + 1);
                tage = az_d + 1;
                // console.log('HR Strom 3', jahr, az_teil_d, (az_d + 1), factor_hochrechnung, az_bis, az_ende);
            } else if (abrechnungsart === 4) {
                // Wir rechnen vom Jahresbeginn bis AZ-Bis
                const az_begin = new Date(jahr, 0, 1).getTime() / 1000;
                const az_teil_d = tage_hochrechnung = Math.round((az_bis - az_begin) / 86400) + 1;
                const az_d = Math.round(az / 86400);
                factor_hochrechnung = az_teil_d / (az_d + 1);
                tage = az_d + 1;
                // console.log('HR Strom 4', jahr, az_teil_d, (az_d + 1), factor_hochrechnung, az_bis, az_begin);
            }
            factor_hochrechnung = Math.round(factor_hochrechnung * 100) / 100;

            const key_messsystem = 'strom_messsystem';
            const key_kalibrierung = 'strom_kalibrierung';
            const key_datenqualitaet = 'strom_datenqualitaet';
            const messsystem = item.messsystem;
            const kalibrierung = item.kalibrierung;
            if (messsystem) {
                if (base[jahr][key_messsystem]) {
                    base[jahr][key_messsystem] += ', ' + messsystem;
                } else {
                    base[jahr][key_messsystem] = messsystem;
                }
            }
            if (kalibrierung) {
                if (base[jahr][key_kalibrierung]) {
                    base[jahr][key_kalibrierung] += ', ' + kalibrierung;
                } else {
                    base[jahr][key_kalibrierung] = kalibrierung;
                }
            }
            if (!base[jahr][key_datenqualitaet]) {
                base[jahr][key_datenqualitaet] = [];
            }

            base[jahr][key_datenqualitaet].push({
                wert: +(item.verbrauch_kwh || 0),
                datenherkunft: +(item.datenherkunft || 0),
                bewertung: 1
            });

            if (standort) {
                const aq: any = getEmissionsFaktorObject(data, '', jahr, 'strom_mix') || {};
                const kosten_netto: number = typeof item.kosten_netto === 'number' ? item.kosten_netto * factor_hochrechnung : null;
                const verbrauch_kwh: number = typeof item.verbrauch_kwh === 'number' ? item.verbrauch_kwh * factor_hochrechnung : null;
                const weitergeleitete_strommenge_kwh: number = typeof item.weitergeleitete_strommenge_kwh === 'number' ? item.weitergeleitete_strommenge_kwh * factor_hochrechnung : null;
                const stromverbrauch_efahrzeuge: number = typeof item.stromverbrauch_efahrzeuge === 'number' ? item.stromverbrauch_efahrzeuge * factor_hochrechnung : null;
                let quelle = 'Emissionsfaktor lt. Versorgerrechnung / Eingabe durch Nutzer';
                base[jahr].kosten_strom = (base[jahr].kosten_strom || 0) + kosten_netto;
                base[jahr].verbrauch_strom = (base[jahr].verbrauch_strom || 0) + verbrauch_kwh;
                base[jahr].weitergeleitete_strommenge_kwh = (base[jahr].weitergeleitete_strommenge_kwh || 0) + weitergeleitete_strommenge_kwh;
                base[jahr].stromverbrauch_efahrzeuge = (base[jahr].stromverbrauch_efahrzeuge || 0) + stromverbrauch_efahrzeuge;
                let co2_faktor = (item.co2_emissionen || item.co2_emissionen === 0) ? item.co2_emissionen / 1000000 : null;
                if (!co2_faktor && co2_faktor !== 0) {
                    quelle = aq.quelle;
                    co2_faktor = aq.wert;
                }
                const co2_emissionen = (verbrauch_kwh || 0) * (co2_faktor || 0);
                const strom_bundesdurchschnitt = typeof item.verbrauch_kwh === 'number' ? verbrauch_kwh : null;
                const co2_bundesdurchschnitt = typeof item.verbrauch_kwh === 'number' ? verbrauch_kwh * aq.wert : null;
                const co2_precalc = typeof item.verbrauch_kwh === 'number' ? co2_emissionen : null;
                // Strom für Bundes
                base[jahr].strom_bundesdurchschnitt = strom_bundesdurchschnitt + (base[jahr].strom_bundesdurchschnitt || 0);
                base[jahr].co2_strom_bundesdurchschnitt = co2_bundesdurchschnitt + (base[jahr].co2_strom_bundesdurchschnitt || 0);
                data[IDs.KENNZIFFERN_BERECHNET][jahr].strom_bundesdurchschnitt = strom_bundesdurchschnitt + ( data[IDs.KENNZIFFERN_BERECHNET][jahr].strom_bundesdurchschnitt || 0);
                data[IDs.KENNZIFFERN_BERECHNET][jahr].co2_strom_bundesdurchschnitt = co2_bundesdurchschnitt + ( data[IDs.KENNZIFFERN_BERECHNET][jahr].co2_strom_bundesdurchschnitt || 0);

                // Strom für Bundesdurchschnitt Ende
                base[jahr].co2_strom_precalc = co2_precalc + (base[jahr].co2_strom_precalc || 0);
                if (base[jahr].verbrauch_strom > 0) {
                    base[jahr].faktor_strom_co2_calc = base[jahr].co2_strom_precalc / base[jahr].verbrauch_strom;
                }
                if (base[jahr].faktor_quelle_strom_co2 && base[jahr].faktor_quelle_strom_co2.indexOf(quelle) === -1) {
                    base[jahr].faktor_quelle_strom_co2 += ';;' + quelle;
                } else {
                    if (!base[jahr].faktor_quelle_strom_co2) {
                        base[jahr].faktor_quelle_strom_co2 = quelle;
                    }
                }
                if (data[IDs.KENNZIFFERN_BERECHNET][jahr].faktor_quelle_strom_co2 && data[IDs.KENNZIFFERN_BERECHNET][jahr].faktor_quelle_strom_co2.indexOf(quelle) === -1) {
                    data[IDs.KENNZIFFERN_BERECHNET][jahr].faktor_quelle_strom_co2 += ';;' + quelle;
                } else {
                    if (!data[IDs.KENNZIFFERN_BERECHNET][jahr].faktor_quelle_strom_co2) {
                        data[IDs.KENNZIFFERN_BERECHNET][jahr].faktor_quelle_strom_co2 = quelle;
                    }
                }
                if (+jahr === 2024) {
                    // console.log('Quelle Strom', quelle, data[IDs.KENNZIFFERN_BERECHNET][jahr].faktor_quelle_strom_co2);
                }
                // <KENNZAHLENBERECHNUNG>
                const kenn_bundesdurchschnitt: Kennzahl = getKennzahl('s2_strom_bundesdurchschnitt', 'verbrauch', jahr, standortTid ? standortTid : 'ALL', data);
                const kenn_bundesdurchschnitt_co2: Kennzahl = getKennzahl('s2_strom_bundesdurchschnitt', 'co2', jahr, standortTid ? standortTid : 'ALL', data);
                const kenn_co2: Kennzahl = getKennzahl('strom_fremdbezug', 'co2', jahr, standortTid ? standortTid : 'ALL', data);
                const kenn_kosten: Kennzahl = getKennzahl('strom_fremdbezug', 'kosten', jahr, standortTid ? standortTid : 'ALL', data);
                const kenn_spitzenlast: Kennzahl = getKennzahl('strom', 'spitzenlast', jahr, standortTid ? standortTid : 'ALL', data);
                const zaehler = item.zaehler_tid_orig ? item.zaehler_tid : null;
                kenn_verbrauch = getKennzahl('strom_fremdbezug', 'verbrauch', jahr, standortTid ? standortTid : 'ALL', data);
                if (!kenn_bundesdurchschnitt.isInitialized()) {
                    kenn_bundesdurchschnitt
                        .setEinheit('kWh')
                        .setBereich(Kennzahl.BEREICH_SCOPE2)
                        .setType(Kennzahl.TYPE_SUMME)
                        .setName('Verbrauch Strom Bundesdurchschnitt');
                }
                if (!kenn_bundesdurchschnitt_co2.isInitialized()) {
                    kenn_bundesdurchschnitt_co2
                        .setEinheit('tCO₂Äq')
                        .setBereich(Kennzahl.BEREICH_SCOPE2)
                        .setType(Kennzahl.TYPE_SUMME)
                        .setName('CO₂-Emission Strom Bundesdurchschnitt');
                }
                if (!kenn_co2.isInitialized()) {
                    kenn_co2
                        .setEinheit('tCO₂Äq')
                        .setBereich(Kennzahl.BEREICH_STROM)
                        .setType(Kennzahl.TYPE_SUMME)
                        .setName('CO₂-Emission Strom Fremdbezug')
                        .setGesamt('strom_gesamt')
                        .setGesamtName('CO₂-Emission Strom Gesamt');
                }
                if (!kenn_kosten.isInitialized()) {
                    kenn_kosten
                        .setEinheit('€')
                        .setBereich(Kennzahl.BEREICH_STROM)
                        .setType(Kennzahl.TYPE_SUMME)
                        .setName('Kosten Strom Fremdbezug')
                        .setGesamt('strom_gesamt')
                        .setGesamtName('Kosten Strom Gesamt');
                }
                if (!kenn_spitzenlast.isInitialized()) {
                    kenn_spitzenlast
                        .setEinheit('kW')
                        .setBereich(Kennzahl.BEREICH_STROM)
                        .setType(Kennzahl.TYPE_MAX)
                        .setName('Spitzenlast Strom');
                }
                if (!kenn_verbrauch.isInitialized()) {
                    kenn_verbrauch
                        .setEinheit('kWh')
                        .setBereich(Kennzahl.BEREICH_STROM)
                        .setType(Kennzahl.TYPE_SUMME)
                        .setName('Verbrauch Strom Fremdbezug')
                        .setGesamt('strom_gesamt')
                        .setGesamtName('Verbrauch Strom Gesamt');
                }
                const kenn_item_bundesdurchschnitt: Kennzahl = kenn_bundesdurchschnitt.addValue(verbrauch_kwh, item.tid);
                const kenn_item_bundesdurchschnitt_co2: Kennzahl = kenn_bundesdurchschnitt_co2.addValue(co2_bundesdurchschnitt, item.tid);
                const kenn_item_co2: Kennzahl = kenn_co2.addValue(co2_precalc, item.tid);
                const kenn_item_kosten: Kennzahl = kenn_kosten.addValue(kosten_netto, item.tid);
                const kenn_item_spitzenlast: Kennzahl = kenn_spitzenlast.addValue(item.spitzenlast, item.tid);
                const kenn_item_verbrauch: Kennzahl = kenn_verbrauch.addValue(verbrauch_kwh, item.tid);
                if (factor_hochrechnung !== 1) {
                    kenn_item_bundesdurchschnitt
                        .setEinheitOrig('kWh')
                        .setValueOrig(item.verbrauch_kwh)
                        .setInfo(zaehler ? `Zähler: ${zaehler}` : undefined)
                        .addFaktor(
                            factor_hochrechnung, KennzahlFaktor.TYPE_HOCHRECHNUNG, 'Abrechnungszeitraum',
                            `Hochrechnung${abrechnungsart_name ? ` [${abrechnungsart_name}]` : ''}`,
                            { tage: { value: tage_hochrechnung, valueOrig: tage } }
                        );
                    kenn_item_kosten
                        .setEinheitOrig('€')
                        .setValueOrig(item.kosten_netto)
                        .addFaktor(
                            factor_hochrechnung, KennzahlFaktor.TYPE_HOCHRECHNUNG, 'Abrechnungszeitraum',
                            `Hochrechnung${abrechnungsart_name ? ` [${abrechnungsart_name}]` : ''}`,
                            { tage: { value: tage_hochrechnung, valueOrig: tage } }
                        );
                    kenn_item_verbrauch
                        .setEinheitOrig('kWh')
                        .setValueOrig(item.verbrauch_kwh)
                        .setInfo(zaehler ? `Zähler: ${zaehler}` : undefined)
                        .addFaktor(
                            factor_hochrechnung, KennzahlFaktor.TYPE_HOCHRECHNUNG, 'Abrechnungszeitraum',
                            `Hochrechnung${abrechnungsart_name ? ` [${abrechnungsart_name}]` : ''}`,
                            { tage: { value: tage_hochrechnung, valueOrig: tage } }
                        );
                }
                kenn_item_bundesdurchschnitt
                    .setType(Kennzahl.TYPE_EINGABE)
                    .setInfo(zaehler ? `Zähler: ${zaehler}` : undefined)
                    .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
                kenn_item_bundesdurchschnitt_co2
                    .setType(Kennzahl.TYPE_BERECHNUNG)
                    .addItem(kenn_item_verbrauch)
                    .setInfo(zaehler ? `Zähler: ${zaehler}` : undefined)
                    .addFaktor(aq.wert, KennzahlFaktor.TYPE_CO2, quelle, 'CO₂-Faktor')
                    .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
                kenn_item_co2
                    .setType(Kennzahl.TYPE_BERECHNUNG)
                    .addItem(kenn_item_verbrauch)
                    .setInfo(zaehler ? `Zähler: ${zaehler}` : undefined)
                    .addFaktor(co2_faktor, KennzahlFaktor.TYPE_CO2, quelle, 'CO₂-Faktor')
                    .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
                kenn_item_kosten
                    .setType(Kennzahl.TYPE_EINGABE)
                    .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
                kenn_item_spitzenlast
                    .setType(Kennzahl.TYPE_EINGABE)
                    .setInfo(zaehler ? `Zähler: ${zaehler}` : undefined)
                    .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
                kenn_item_verbrauch
                    .setType(Kennzahl.TYPE_EINGABE)
                    .setInfo(zaehler ? `Zähler: ${zaehler}` : undefined)
                    .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
                // </KENNZAHLENBERECHNUNG>

                // setRenewable
                if (isRenewableStrom(co2_faktor)) {
                    base[jahr].verbrauch_strom_regenerativ = (base[jahr].verbrauch_strom_regenerativ || 0) + verbrauch_kwh;
                    base[jahr].co2_strom_precalc_renewable = co2_precalc + (base[jahr].co2_strom_precalc_renewable || 0);
                    base[jahr].verbrauch_strom_renewable = (base[jahr].verbrauch_strom_renewable || 0) + verbrauch_kwh;
                    base[jahr].co2_strom_renewable = (base[jahr].co2_strom_renewable || 0) + co2_emissionen;
                    base[jahr].verbrauch_strom_einkauf_renewable = (base[jahr].verbrauch_strom_einkauf_renewable || 0) + verbrauch_kwh;
                    setKennzahlRenewableStrom(item, data, verbrauch_kwh, co2_emissionen, kenn_verbrauch, kenn_co2);
                } else {
                    base[jahr].verbrauch_strom_konventionell = (base[jahr].verbrauch_strom_konventionell || 0) + verbrauch_kwh;
                }
            }
            base[jahr].spitzenlast_strom = (!base[jahr].spitzenlast_strom || base[jahr].spitzenlast_strom < item.spitzenlast)
                ? item.spitzenlast : base[jahr].spitzenlast_strom;
            // console.log('Extr Strom: ', jahr, item.co2_emissionen, base[jahr].faktor_strom_co2);
            // AZ
            base[jahr].az_von_strom = (!base[jahr].az_von_strom || base[jahr].az_von_strom > item.abrechnungszeitraum_von)
                ? item.abrechnungszeitraum_von : base[jahr].az_von_strom;
            base[jahr].az_bis_strom = (!base[jahr].az_bis_strom || base[jahr].az_bis_strom < item.abrechnungszeitraum_bis)
                ? item.abrechnungszeitraum_bis : base[jahr].az_bis_strom;
            // console.log('Strom Item extr.', standort, base[jahr]);
        }
    });

    /******************** GTZ HOCHRECHNUNG ****************************************************************** */

    if (standort) {
        // console.log('??? 1', standort.name);
        Object.keys(base).forEach((jahr: any) => {
            if (+jahr > 0) {
                const az_von = base[jahr].az_von_strom;
                const az_bis = base[jahr].az_bis_strom;
                if (!az_von || !az_bis) {
                    return;
                }
                const kosten_in = base[jahr].kosten_strom;
                const verbrauch_in = base[jahr].verbrauch_strom;
                const co2_strom_precalc = base[jahr].co2_strom_precalc;
                const verbrauch_strom_renewable = base[jahr].verbrauch_strom_renewable;
                const verbrauch_strom_einkauf_renewable = base[jahr].verbrauch_strom_einkauf_renewable;
                const verbrauch_strom_konventionell = base[jahr].verbrauch_strom_konventionell;
                const co2_strom_precalc_renewable = base[jahr].co2_strom_precalc;

                // Strom & Energiesteuer
                data[IDs.KENNZIFFERN_BERECHNET][jahr].strom_stromverbrauch_efahrzeuge =
                    (data[IDs.KENNZIFFERN_BERECHNET][jahr].strom_stromverbrauch_efahrzeuge || 0) + (base[jahr].stromverbrauch_efahrzeuge || 0);
                data[IDs.KENNZIFFERN_BERECHNET][jahr].strom_weitergeleitete_strommenge_kwh =
                    (data[IDs.KENNZIFFERN_BERECHNET][jahr].strom_weitergeleitete_strommenge_kwh || 0) + + (base[jahr].weitergeleitete_strommenge_kwh || 0);

                // CO2-Fussabdruck Start
                base[jahr].co2_fussabdruck_strom_menge = verbrauch_in;

                // CO2-Fussabdruck Ende
                base[jahr].verbrauch_strom = verbrauch_in;
                base[jahr].kosten_strom = kosten_in;
                base[jahr].kosten_total = (base[jahr].kosten_total || 0) + kosten_in;
                base[jahr].verbrauch_total = (base[jahr].verbrauch_total || 0) + verbrauch_in;
                data[IDs.KENNZIFFERN_BERECHNET][jahr].kosten_total =
                    (data[IDs.KENNZIFFERN_BERECHNET][jahr].kosten_total || 0) + kosten_in;
                data[IDs.KENNZIFFERN_BERECHNET][jahr].kosten_strom =
                    (data[IDs.KENNZIFFERN_BERECHNET][jahr].kosten_strom || 0) + kosten_in;
                data[IDs.KENNZIFFERN_BERECHNET][jahr].verbrauch_total =
                    (data[IDs.KENNZIFFERN_BERECHNET][jahr].verbrauch_total || 0) + verbrauch_in;
                data[IDs.KENNZIFFERN_BERECHNET][jahr].verbrauch_strom =
                    (data[IDs.KENNZIFFERN_BERECHNET][jahr].verbrauch_strom || 0) + verbrauch_in;
                data[IDs.KENNZIFFERN_BERECHNET][jahr].verbrauch_strom_konventionell =
                    (data[IDs.KENNZIFFERN_BERECHNET][jahr].verbrauch_strom_konventionell || 0) + verbrauch_strom_konventionell;
                data[IDs.KENNZIFFERN_BERECHNET][jahr].verbrauch_strom_einkauf_renewable =
                    (data[IDs.KENNZIFFERN_BERECHNET][jahr].verbrauch_strom_einkauf_renewable || 0) + verbrauch_strom_einkauf_renewable;
                data[IDs.KENNZIFFERN_BERECHNET][jahr].verbrauch_strom_renewable =
                    (data[IDs.KENNZIFFERN_BERECHNET][jahr].verbrauch_strom_renewable || 0) + verbrauch_strom_renewable;
                data[IDs.KENNZIFFERN_BERECHNET][jahr].co2_fussabdruck_strom_menge =
                    (data[IDs.KENNZIFFERN_BERECHNET][jahr].co2_fussabdruck_strom_menge || 0) + verbrauch_in;

                // CO2
                data[IDs.KENNZIFFERN_BERECHNET][jahr].co2_strom_precalc = co2_strom_precalc + (data[IDs.KENNZIFFERN_BERECHNET][jahr].co2_strom_precalc || 0);

                if (data[IDs.KENNZIFFERN_BERECHNET][jahr].verbrauch_strom > 0) {
                    data[IDs.KENNZIFFERN_BERECHNET][jahr].faktor_strom_co2_calc = data[IDs.KENNZIFFERN_BERECHNET][jahr].co2_strom_precalc /
                        data[IDs.KENNZIFFERN_BERECHNET][jahr].verbrauch_strom;
                }
            }
        });
    }
    /******************** EIGEN STROM ****************************************************************** */
    eigenstrom.forEach((item: any) => {
        const standortTid = item.standort_tid_orig ? item.standort_tid_orig : item.standort_tid;
        if (!standortTid || !standorteMap[standortTid]) {
            return;
        }
        // console.log('Eigenstrom: ', item);
        if (
            (!item.monat || item.monat === 0) // nur Jahreswerte
            && isValidStrom(item, IDs.ENT_ENERGIEDATEN_EIGENSTROM)
        ) {
            const jahr = item.jahr;
            const typ_tid = item.anlagen_eigenstrom_typ_tid;
            if (!base[jahr]) {
                base[jahr] = {};
            }
            // console.log('Eigenstrom Item', item);
            let co2_key = null;
            let typ_key = null;
            switch (true) {
                case typ_tid === 'Photovoltaik' || typ_tid === 2:
                    co2_key = typ_key = 'pv';
                    break;
                case typ_tid === 'Kraft-Wärme-Kopplung' || typ_tid === 3:
                    typ_key = 'kwk';
                    break;
                case typ_tid === 'Windkraft' || typ_tid === 1:
                    co2_key = typ_key = 'wind';
                    break;
            }
            if (co2_key) {
                base[jahr][`co2_fussabdruck_${co2_key}_menge`] = item.eigenverbrauch_kwh;
            }
            if (typ_key) {
                base[jahr][`eigenstrom_${typ_key}_produktion_kwh`] = item.gesamtproduktion_kwh;
            }
            const key_datenqualitaet = `${co2_key}_datenqualitaet`;
            if (!base[jahr][key_datenqualitaet]) {
                base[jahr][key_datenqualitaet] = [];
            }
            base[jahr][key_datenqualitaet].push({
                wert: +(item.eigenverbrauch_kwh || 0),
                datenherkunft: +(item.datenherkunft || 0),
                bewertung: 1
            });
            base['flags'].hasEigenstrom = true;
            base[jahr].verbrauch_strom_regenerativ = (base[jahr].verbrauch_strom_regenerativ || 0) + (+item.eigenverbrauch_kwh);
            base[jahr].eigenstrom_verbrauch_kwh = (base[jahr].eigenstrom_verbrauch_kwh || 0) + item.eigenverbrauch_kwh;
            base[jahr].eigenstrom_einspeisung_kwh = (base[jahr].eigenstrom_einspeisung_kwh || 0) + item.netzeinspeisung_kwh;
            base[jahr].eigenstrom_einspeisung_verguetung = (base[jahr].eigenstrom_einspeisung_verguetung || 0) + item.einspeiseverguetung;
            // hier muss noch der Eigenstromverbrauch ergänzt werden...
            base[jahr].verbrauch_total = (base[jahr].verbrauch_total || 0) + +item.eigenverbrauch_kwh;
            // <KENNZAHLENBERECHNUNG>
            const kenn_einspeisung: Kennzahl = getKennzahl('eigenstrom', 'einspeisung', jahr, standortTid ? standortTid : 'ALL', data);
            const kenn_einspeiseverguetung: Kennzahl = getKennzahl('eigenstrom', 'einspeiseverguetung', jahr, standortTid ? standortTid : 'ALL', data);
            kenn_verbrauch = getKennzahl('eigenstrom', 'verbrauch', jahr, standortTid ? standortTid : 'ALL', data);
            const anlage = item.anlagen_eigenstrom_typ_tid_orig ? item.anlagen_eigenstrom_typ_tid : null;
            if (!kenn_einspeiseverguetung.isInitialized()) {
                kenn_einspeiseverguetung
                    .setEinheit('€')
                    .setBereich(Kennzahl.BEREICH_STROM)
                    .setType(Kennzahl.TYPE_SUMME)
                    .setName('Einspeisevergütung Strom');
            }
            if (!kenn_einspeisung.isInitialized()) {
                kenn_einspeisung
                    .setEinheit('kWh')
                    .setBereich(Kennzahl.BEREICH_STROM)
                    .setType(Kennzahl.TYPE_SUMME)
                    .setName('Einspeisung Strom');
            }
            if (!kenn_verbrauch.isInitialized()) {
                kenn_verbrauch.setEinheit('kWh')
                    .setBereich(Kennzahl.BEREICH_STROM)
                    .setType(Kennzahl.TYPE_SUMME)
                    .setName('Verbrauch Eigenstrom')
                    .setGesamt('strom_gesamt')
                    .setGesamtName('Verbrauch Strom Gesamt');
            }
            const kenn_item_einspeiseverguetung: Kennzahl = kenn_einspeiseverguetung.addValue(item.einspeiseverguetung, item.tid);
            const kenn_item_einspeisung: Kennzahl = kenn_einspeisung.addValue(item.netzeinspeisung_kwh, item.tid);
            const kenn_item_verbrauch: Kennzahl = kenn_verbrauch.addValue(item.eigenverbrauch_kwh, item.tid);
            kenn_item_einspeiseverguetung
                .setType(Kennzahl.TYPE_EINGABE)
                .setInfo(anlage ? `Anlage: ${anlage}` : undefined)
                .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
            kenn_item_einspeisung
                .setType(Kennzahl.TYPE_EINGABE)
                .setInfo(anlage ? `Anlage: ${anlage}` : undefined)
                .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
            kenn_item_verbrauch
                .setType(Kennzahl.TYPE_EINGABE)
                .setInfo(anlage ? `Anlage: ${anlage}` : undefined)
                .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
            // </KENNZAHLENBERECHNUNG>

            // setRenewable
            // Stromverbrauch aus selbst erzeugter Elektrizität = Eigenstrom - Netzeinspeisung
            if (true) {
                // Siehe onFormChangeEigenstrom()
                // Eigenverbrauch = Gesamtproduktion - Netzeinspeisung
                const verbrauch = item.eigenverbrauch_kwh || 0;
                base[jahr].verbrauch_eigenstrom_renewable = (base[jahr].verbrauch_eigenstrom_renewable || 0) + verbrauch;
                base[jahr].verbrauch_strom_renewable = (base[jahr].verbrauch_strom_renewable || 0) + verbrauch;
                setKennzahlRenewableStrom(item, data, verbrauch, undefined, kenn_verbrauch);
            }
        }
    });
    // console.log('POST STROM: ', JSON.stringify(base));
}

